export default __webpack_public_path__ + "static/media/gluten.003614ec.svg";